import React, { useState, useEffect } from 'react';
import Moment from 'moment';
import { useTranslation } from 'react-i18next';

const ResultadoSolicitud = () => {
  const { t } = useTranslation();
  const ref = React.createRef();
  const [Resultado, setResultado] = useState("");
  const [ResulSb, setResulSb] = useState("");

  function VolverAlInicio() {
    window.localStorage.clear();
    window.location.href = "https://aviorair.com";
  }
  
  const NroReembolso = window.localStorage.getItem("NroReembolso");
  const hoy = new Date();

  useEffect(() => {
    const Resul = window.localStorage.getItem("Resultado");
    const ResulSb = window.localStorage.getItem("ResultadoSb");
    setResultado(Resul);
    setResulSb(ResulSb);
 
    const stepBar = document.getElementsByClassName('_3uApM ')[0];
    if (stepBar) {
      stepBar.style.display = 'none';
    }
  }, []);

  return (
    <>
      <div className="_pb-90 _pt-30 container-fluid">
        <div className="row justify-content-center">
          <div className="col-12 col-md-6 col-lg-4">
            <div className="theme-payment-success shadow-sm rounded">
              <div className="theme-payment-success-header text-center">
                <i className="fa fa-check-circle theme-payment-success-header-icon text-success mb-3" style={{ fontSize: '48px' }}></i>
                <h1 className="theme-payment-success-title h3">{Resultado || t('resultado.tituloDefecto', 'Solicitud Procesada')}</h1>
                <p className="theme-payment-success-subtitle">{ResulSb || t('resultado.subtituloDefecto', 'Su solicitud ha sido recibida con éxito.')}</p>
              </div>
              <div ref={ref}>
                <div className="theme-payment-success-box p-4 bg-light rounded mt-3">
                  <ul className="theme-payment-success-summary list-unstyled">
                    <li className="d-flex justify-content-between mb-2">
                      <span className="font-weight-bold">{t('resultado.nroSolicitud', 'N° de solicitud')}</span>
                      <span>#{NroReembolso}</span>
                    </li>
                    <li className="d-flex justify-content-between mb-2">
                      <span className="font-weight-bold">{t('resultado.fechaEmision', 'Fecha de emisión')}</span>
                      <span>{Moment(hoy).format("DD/MM/YYYY")}</span>
                    </li>
                  </ul>
                  <p className="theme-payment-success-check-order text-center mt-4">
                    {t('resultado.mensajePronto', 'Pronto estaremos comunicándonos con usted.')}
                  </p>
                </div>
                <hr className="style2 my-4" />
              </div>
              <ul className="theme-payment-success-actions hover-Oscuro list-unstyled text-center">
                <li>
                  <a className="seleccionable hover-Oscuro text-decoration-none" onClick={VolverAlInicio} style={{ cursor: 'pointer' }}>
                    <i className="fa fa-home mb-2 d-block" style={{ fontSize: '24px' }}></i>
                    <p className="m-0">
                      {t('resultado.irA', 'Ir a')}
                      <br />
                      {t('resultado.inicio', 'Inicio')}
                    </p>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ResultadoSolicitud;